import {
    ChipList as UiChipList,
    styledForMobile,
    styled,
    Typography,
} from "@l2r-front/l2r-ui"


import { StatusSelector as L2RStatusSelector } from "../StatusSelector"

export const Container = styledForMobile("div")(() => ({
    flex: "1 1 auto",
    display: "flex",
    flexDirection: "column",
    minHeight: "100%",
    overflowY: "auto",
}))

export const CampaignTitleContainer = styled("div")(({ theme }) => ({
    alignItems: "center",
    display: "flex",
    gap: theme.spacing(3),
    padding: theme.spacing(5, 8, 0, 8),
    marginBottom: theme.spacing(5),
}))

export const Color = styled("div")(({ color }) => ({
    backgroundColor: color,
    borderRadius: 4,
    height: 24,
    width: 24,
}))

export const CampaignDescription = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
    padding: theme.spacing(8),
}))

export const CampaignItemContainer = styled("div")(({ theme }) => ({
    display: "flex",
    gap: theme.spacing(2),
}))

export const ContentText = styledForMobile(Typography)(({ color, isMobile, theme }) => ({
    color: theme.palette[color].main,
    width: isMobile ? "fit-content" : "50%",
}))

export const ChipList = styledForMobile(UiChipList)(({ isMobile }) => ({
    width: !isMobile && "50%",
}))

export const ContentContainer = styledForMobile("div")(({ theme }) => ({
    backgroundColor: theme.palette["action/hover"].main,
    padding: theme.spacing(8, 8, 0, 8),
    flex: "1 1 auto",
}))

export const StatusSelector = styled(L2RStatusSelector)(({ theme }) => ({
    marginLeft: theme.spacing(8),
}))